import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

export const companyBillingActivity = {

    namespaced: true,

    state:
    {
        ...baseStates,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters
    },
};
